import { QueryClient, focusManager } from '@tanstack/react-query'

focusManager.setEventListener((handleFocus) => {
  if (typeof window === 'undefined') return undefined
  const listener = () => handleFocus()
  document.addEventListener('visibilitychange', listener, false)
  window.addEventListener('focus', listener, false)
  return () => {
    document.removeEventListener('visibilitychange', listener)
    window.removeEventListener('focus', listener)
  }
})

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})
